<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="showRegisterModal"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <p class="headline">
            {{ $t("message.hello") }} {{ form.fname }},
            {{ $t("message.registering") }}
          </p>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex
                xs12
                sm6
                md6
              >
                <v-text-field
                  v-model.trim="fname"
                  :label="firsts"
                  :rules="firstrules"
                  required
                />
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
              >
                <v-text-field
                  v-model.trim="lname"
                  :label="lasts"
                  :rules="lastrules"
                  required
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model.trim="address"
                  :label="streets"
                  :rules="streetrules"
                />
              </v-flex>
              <v-flex
                xs12
                sm6
                md4
              >
                <v-text-field
                  v-model.trim="city"
                  :label="cities"
                  :rules="cityrules"
                />
              </v-flex>
              <v-flex
                xs12
                sm6
                md4
              >
                <v-select
                  v-model="state"
                  :items="states"
                  :label="langstate"
                />
              </v-flex>
              <v-flex
                xs12
                sm6
                md4
              >
                <v-text-field
                  v-model.trim="postalCode"
                  :label="zips"
                  required
                  :rules="ziprules"
                  :error="isInvalidZip"
                  :error-messages="errorMessage"
                  @input="isInvalidZip = false"
                />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model.trim="phone"
                  :label="phones"
                  :rules="phonerules"
                />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model.trim="email"
                  :label="emails"
                  :rules="emailrules"
                />
              </v-flex>
            </v-layout>
          </v-container>
          <small>*{{ $t("message.required") }}</small>
        </v-card-text>
        <SurveySelectDropdown
          v-if="shouldShowSurveySelect"
          @set-survey="setSurvey"
        />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="toggleRegisterModal"
          >
            {{ $t("message.cancel") }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :disabled="
              $v.fname.$invalid ||
                $v.lname.$invalid ||
                $v.address.$invalid ||
                $v.city.$invalid ||
                $v.postalCode.$invalid ||
                $v.phone.$invalid ||
                $v.email.$invalid ||
                noSurveySelected
            "
            @click="addStakeholderBtn"
          >
            {{ $t("message.register") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import SurveySelectDropdown from "@/components/StakeholderLookup/SurveySelectDropdown.vue";

import states from "@/states.js";
import rules from "@/validation.js";
import esrules from "@/esvalidation.js";
import validations from "@/validation.js";

import { mapState } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { mapActions } from "vuex";

const { mapFields } = createHelpers({
  getterType: `stakeholders/getField`,
  mutationType: `stakeholders/updateField`
});

export default {
  name: "Register",
  components: {
    SurveySelectDropdown
  },
  data: () => ({
    visible: true,
    states: states,
    rules: rules.rules,
    esrules: esrules.esrules,
    isInvalidZip: false,
    surveyToNavigateTo: {}
  }),
  computed: {
    ...mapFields([
      "form.fname",
      "form.lname",
      "form.address",
      "form.city",
      "form.state",
      "form.postalCode",
      "form.phone",
      "form.email",
      "currentStakeholderID"
    ]),
    ...mapState("stakeholders", ["form", "showRegisterModal"]),
    ...mapState({
      surveys: state => state.survey.surveys,
      programs: state => state.programs.programs
    }),
    shouldShowSurveySelect() {
      if (Object.keys(this.$router.currentRoute.params).length > 1) {
        return false;
      }
      const programNameFromURL = this.$router.currentRoute.params.program_name;
      return this.programs.find(program => this.toUpperCase(program.name) === this.toUpperCase(programNameFromURL.replace(/_/g, " "))).view_multiple_surveys
    },
    noSurveySelected() {
      return (
        this.shouldShowSurveySelect &&
        Object.entries(this.surveyToNavigateTo).length === 0
      );
    },
    firstrules: function() {
      if (this.$i18n.locale === "en") {
        return this.rules.fnameRules;
      } else {
        return this.esrules.fnameRules;
      }
    },
    lastrules: function() {
      if (this.$i18n.locale === "en") {
        return this.rules.lnameRules;
      } else {
        return this.esrules.lnameRules;
      }
    },
    ziprules: function() {
      if (this.$i18n.locale === "en") {
        return this.rules.postalCodeRules;
      } else {
        return this.esrules.postalCodeRules;
      }
    },
    streetrules: function() {
      if (this.$i18n.locale === "en") {
        return this.rules.streetAddressRules;
      } else {
        return this.esrules.streetAddressRules;
      }
    },
    cityrules: function() {
      if (this.$i18n.locale === "en") {
        return this.rules.cityRules;
      } else {
        return this.esrules.cityRules;
      }
    },
    phonerules: function() {
      if (this.$i18n.locale === "en") {
        return this.rules.phoneRules;
      } else {
        return this.esrules.phoneRules;
      }
    },
    emailrules: function() {
      if (this.$i18n.locale === "en") {
        return this.rules.emailRules;
      } else {
        return this.esrules.emailRules;
      }
    },
    firsts() {
      return this.$t("message.first") + "*";
    },
    lasts() {
      return this.$t("message.last") + "*";
    },
    zips() {
      return this.$t("message.zip") + "*";
    },
    streets() {
      return this.$t("message.address");
    },
    cities() {
      return this.$t("message.city");
    },
    langstate() {
      return this.$t("message.state") + "*";
    },
    phones() {
      return this.$t("message.phone");
    },
    emails() {
      return this.$t("message.email");
    },
    errorMessage() {
      if (this.isInvalidZip === true) {
        return "Postal code is invalid";
      }
      return "";
    }
  },
  validations: validations.validations,
  methods: {
    ...mapActions("stakeholders", [
      "setContactID",
      "showNetworkAlert",
      "showDuplicateAlert",
      "toggleRegisterModal",
      "toggleUpdateModal",
      "addStakeholder",
      "updateStakeholder",
      "createGeocode"
    ]),
    ...mapActions("auth", ["setToken"]),
    navigateToSurvey() {
      let dashboardFiltering;
      if (Object.keys(this.surveyToNavigateTo).length !== 0) {
        dashboardFiltering = this.surveyToNavigateTo.survey_metadata.meta_data.dashboardFiltering;
      }
      const fromRouter = this.$router.currentRoute.params;
      const routerParams = {
        program_name: this.$router.currentRoute.params.program_name,
        project_name: this.shouldShowSurveySelect ? this.formatName(dashboardFiltering.project) : fromRouter.project_name,
        survey_name: this.shouldShowSurveySelect ? this.formatName(dashboardFiltering.survey) : fromRouter.survey_name
      };
      this.$router.push({
        name: "survey",
        params: routerParams
      })
    },
    sanitize(payload) {
      for (let [field, value] of Object.entries(payload)) {
        if (!value) {
          payload[field] = null;
        }
      }
    },
    addStakeholderBtn() {
      if (this.form.address) {
        this.form.address = this.form.address.replace(/[\W_]+/g, " ");
      }

      let payload = {
        first_name: this.fname,
        last_name: this.lname,
        postal_code: this.postalCode,
        address: this.address,
        city: this.city,
        state: this.state,
        phone: this.phone,
        email: this.email,
      };

      this.sanitize(payload);

      this.createGeocode(payload).then(response => {
        if (response === "unavailable") {
          this.addStakeholder(payload).then(() => {
            this.navigateToSurvey();
          });
        } else {
          if (response.location === undefined) {
            this.isInvalidZip = true;
          } else {
            payload["longitude"] = response.location.x;
            payload["latitude"] = response.location.y;
            this.addStakeholder(payload).then(() => {
              this.navigateToSurvey();
            });
          }
        }
      });
    },
    clickButton() {
      this.$refs.registerButton.click();
    },
    setSurvey(survey) {
      this.surveyToNavigateTo = survey;
    },
    formatName(name) {
      return (name).replace(/ /g, "_")
    },
    toUpperCase(name) {
      return (name).toUpperCase()
    },
  }
};
</script>

<style scoped>
.zipError {
  border-top: -5%;
  color: #e53935;
}
</style>
